import apiClient from './client'

export interface Stats {
  accounts: {
    total: number
    active: number
    pending: number
    verified: number
  }
  apps: {
    total: number
    active: number
  }
  users: {
    total: number
    active: number
  }
}

export interface Account {
  id: number
  email: string
  status: 'active' | 'pending' | 'suspended'
  email_verified: boolean
  created_at: string
  updated_at: string
}

export interface App {
  id: number
  app_id: string
  name: string
  description: string | null
  status: 'active' | 'inactive'
  created_at: string
  updated_at: string
  user_count?: number
}

export interface User {
  id: number
  account_id: number
  app_id: string
  user_id: string
  status: 'active' | 'inactive'
  created_at: string
  updated_at: string
  account_email?: string
  app_name?: string
}

export interface PaginatedResponse<T> {
  items: T[]
  total: number
  page: number
  pageSize: number
  totalPages: number
}

// 管理员登录
export const adminLogin = (email: string, password: string) =>
  apiClient.post('/admin/login', { email, password })

// 获取统计数据
export const getStats = () =>
  apiClient.get<{ success: boolean; data: Stats }>('/admin/stats')

// 获取账户列表
export const getAccounts = (page = 1, pageSize = 20, includeAdmin = true) =>
  apiClient.get<{ success: boolean; data: PaginatedResponse<Account> }>('/admin/accounts', {
    params: { page, pageSize, includeAdmin },
  })

// 修改密码 (管理员)
export const changeAccountPassword = (id: number, newPassword: string) =>
  apiClient.put(`/admin/accounts/${id}/password`, { newPassword })

// 获取账户详情
export const getAccountDetail = (id: number) =>
  apiClient.get<{ success: boolean; data: { account: Account; apps: any[] } }>(`/admin/accounts/${id}`)

// 更新账户状态
export const updateAccountStatus = (id: number, status: string) =>
  apiClient.put(`/admin/accounts/${id}/status`, { status })

// 获取应用列表
export const getApps = (page = 1, pageSize = 20) =>
  apiClient.get<{ success: boolean; data: PaginatedResponse<App> }>('/admin/apps', {
    params: { page, pageSize },
  })

// 创建应用
export const createApp = (data: { appId: string; name: string; description?: string }) =>
  apiClient.post('/apps', data)

// 更新应用
export const updateApp = (appId: string, data: { name?: string; description?: string; status?: string }) =>
  apiClient.put(`/apps/${appId}`, data)

// 删除应用
export const deleteApp = (appId: string) =>
  apiClient.delete(`/apps/${appId}`)

// 获取用户列表
export const getUsers = (page = 1, pageSize = 20) =>
  apiClient.get<{ success: boolean; data: PaginatedResponse<User> }>('/admin/users', {
    params: { page, pageSize },
  })

// 获取用户扩展数据 (管理员)
export const getUserData = (appId: string, userId: string) =>
  apiClient.get<{ success: boolean; data: { user: any; data: any } }>(`/admin/data/${appId}/${userId}`)

// 获取/更新 API 文档白名单
export const getDocsWhitelist = () =>
  apiClient.get<{ success: boolean; data: { envValue: string; kvValue: string } }>('/admin/config/docs-whitelist')

export const updateDocsWhitelist = (whitelist: string) =>
  apiClient.put('/admin/config/docs-whitelist', { whitelist })
